import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-xl pt-[16px] pb-[32px] px-[24px] w-[391px] bg-theme-grey" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["type"]
const _hoisted_4 = { class: "absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 z-30" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 z-30" }
const _hoisted_9 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_Base = _resolveComponent("Base")!

  return (_openBlock(), _createBlock(_component_Base, null, {
    basecontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "hello mt-5 mb-3 text-center" }, "Password Setup", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-[16px] text-center text-white" }, " Looks like it’s your first time here, let’s begin by setting up your new password! ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
          ref: "forgotPassForm_"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper relative ' + (_ctx.form.password.error_type))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "mt-3 block label-text" }, "New Password ", -1)),
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                class: "shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password.value) = $event)),
                type: _ctx.showpassword ? 'text' : 'password',
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateBothField()))
              }, null, 40, _hoisted_3), [
                [_vModelDynamic, _ctx.form.password.value]
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_EyeIcon, {
                  class: _normalizeClass([{'hidden': !_ctx.showpassword, 'block':_ctx.showpassword }, "text-white w-5"]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showpassword = !_ctx.showpassword))
                }, null, 8, ["class"]),
                _createVNode(_component_EyeOffIcon, {
                  class: _normalizeClass([{'block': !_ctx.showpassword, 'hidden':_ctx.showpassword }, "text-white w-5"]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showpassword = !_ctx.showpassword))
                }, null, 8, ["class"])
              ])
            ]),
            (_ctx.form.password.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.password.error_message)
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.confirm_password.error_type))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "mt-3 block label-text" }, "Confirm Password ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.confirm_password.value) = $event)),
                type: _ctx.shownewpassword ? 'text' : 'password',
                onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFields(['confirm_password'])))
              }, null, 40, _hoisted_7), [
                [_vModelDynamic, _ctx.form.confirm_password.value]
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_EyeIcon, {
                  class: _normalizeClass([{'hidden': !_ctx.shownewpassword, 'block':_ctx.shownewpassword }, "text-white w-5"]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.shownewpassword = !_ctx.shownewpassword))
                }, null, 8, ["class"]),
                _createVNode(_component_EyeOffIcon, {
                  class: _normalizeClass([{'block': !_ctx.shownewpassword, 'hidden':_ctx.shownewpassword }, "text-white w-5"]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.shownewpassword = !_ctx.shownewpassword))
                }, null, 8, ["class"])
              ])
            ]),
            (_ctx.form.confirm_password.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.confirm_password.error_message)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2),
          _cache[11] || (_cache[11] = _createElementVNode("button", { class: "mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px]" }, " SET PASSWORD ", -1))
        ], 544)
      ])
    ]),
    _: 1
  }))
}